import type { BuilderContent } from '@builder.io/sdk'

import { BuilderAds } from '@/legacy/components/Advertising'
import type { CustomPublication } from '@/legacy/components/ArticleDate'
import ArticlePublicationDetails from '@/legacy/components/ArticlePublicationDetails'
import { BlogBreadcrumb } from '@/legacy/components/BlogBreadcrumb'
import { SharingButtonsComponent as SharingButtons } from '@/legacy/components/SharingButtons'

import type { ArticleImageProps } from '@/legacy/models'

import * as ModernLayoutStyles from '../../../styles'

interface HeroSectionProps {
  title: string
  subtitle?: string
  adsTop: BuilderContent
  image: ArticleImageProps
  category: string
  customPublication: CustomPublication
}

export default function HeroSection({
  title,
  subtitle,
  image,
  adsTop,
  category,
  customPublication,
}: HeroSectionProps) {
  return (
    <>
      <BlogBreadcrumb />
      <ModernLayoutStyles.TitleWrapper>
        {title && <ModernLayoutStyles.Title tag="h1" html={title} />}
        {subtitle && <ModernLayoutStyles.Subtitle tag="h2" color="dark-high" html={subtitle} />}
        <ArticlePublicationDetails
          category={category}
          publicationDetails={customPublication}
          {...customPublication}
        />
        <SharingButtons />
        <ModernLayoutStyles.HeroImage
          source={image.large}
          alt={image.alt}
          height="480"
          width="928"
          layout="responsive"
        />
      </ModernLayoutStyles.TitleWrapper>
      <BuilderAds position="top" adsContent={adsTop} />
    </>
  )
}
